define('app/views/scheduled_deals_view',['app/setup'],function(takhfifan) {
  takhfifan.scheduledDealsView= Backbone.View.extend({
  events: {
  },
  initialize: function(options) {
    //this.regularDealsFetch();
    var _this = this;
    _this.regularDealsFetch();
    _this.setTimeRemaining();
    _this.isAlreadyFetchingDeals = false;
    _this.listOfDealsBeingShown = {}
  },
  regularDealsFetch: function() {
    var _this = this;
    _this.fetchDealsInfo();
    _.delay(function() {
      _this.regularDealsFetch();
    }, 30000);
  },
  setTimeRemaining: function() {
    var _this = this;
    if(!_.isUndefined(_this.latestServerTimeReference)) {
      _this.latestServerTimeReference += 1;
       var list_of_deals = {}
      _this.$('.deal-box').each(function(obj){
        var date = new Date(null);
        var innerThis = $(this);
        var currenttime = _this.latestServerTimeReference;
        if(!innerThis.hasClass('deactive') &&
           !innerThis.hasClass('sold-out') &&
           !innerThis.hasClass('markedAsDone') &&
           !innerThis.hasClass('loading')
           ) {
            list_of_deals[$(this).data('productid')] = 1;
        }
        if(!_.isUndefined(innerThis.data('starttime')) &&
          !_.isUndefined(innerThis.data('endtime'))
          ) {
            var remaining_seconds = innerThis.data('endtime') - currenttime - 1;
            var timetoactivate_seconds = innerThis.data('starttime') - currenttime - 1;
            if(remaining_seconds > 0 && !innerThis.hasClass('markedAsDone')) {
              date.setSeconds(remaining_seconds);
              innerThis.find('.count-down').html(date.toISOString().substr(11, 8));
            }
            if(remaining_seconds <= 0 && !innerThis.hasClass('markedAsDone')) {
              innerThis.removeClass('deactive');
              innerThis.removeClass('sold-out');
              innerThis.removeClass('loading');
              innerThis.addClass('sold-out flip');
              innerThis.addClass('markedAsDone');
              _this.fetchDealsInfo();
            }
            if(remaining_seconds > 0
                && timetoactivate_seconds < 0
                && !innerThis.hasClass('markedAsDone')
                && innerThis.hasClass('deactive')
                ) {
              _this.fetchDealsInfo();
            }
          }
      });
      _this.listOfDealsBeingShown = list_of_deals;
      _this.forceFetchWhenStillActiveAndSoldOutDeals();
    }
    setTimeout(function(){_this.setTimeRemaining()}, 1000);
  },

  forceFetchWhenStillActiveAndSoldOutDeals: function() {
    var hasActive = false;
    var hasSoldOut= false;
    var _this = this;
    _this.$('.deal-box').each(function(obj){
      if($(this).hasClass('sold-out')) {
        hasSoldOut = true;
      }
      if(!$(this).hasClass('deactive') &&
        !$(this).hasClass('sold-out') &&
        !$(this).hasClass('loading')
        ) {
          hasActive= true;
        }
    });
    if(hasActive && hasSoldOut) {
      _this.fetchDealsInfo();
    }
  },

  fetchDealsInfo: function() {
    var catId = this.$el.data('catid');
    var _this = this;
    var goOnWithFetch = false;
    var date = new Date(null);
    var currenttime = parseInt(new Date().getTime()/1000);
    if(_.isUndefined(_this.lastmaderequesttime)) {
      goOnWithFetch = true;
      _this.lastmaderequesttime = currenttime;
    }
    else {
      if(currenttime - _this.lastmaderequesttime >= 10) {
        goOnWithFetch = true;
        _this.lastmaderequesttime = currenttime;
      }
    }
    if(goOnWithFetch) {
      $.get('/speedydeals/catId/'
          + catId,function(data){
            var forceProceed = false;
            if(_.isUndefined(_this.latestServerResponse) || _this.latestServerResponse != JSON.stringify(data)) {
              _this.latestServerTimeReference = data.timeReference;
              _this.latestServerResponse = JSON.stringify(data);
              forceProceed = true;
            }
            if(forceProceed) {
              if(!_.isUndefined(data.selectedDeals) && data.selectedDeals.length > 0) {
                var validToProceed = false;
                _.each(data.selectedDeals,function(selectedDeal) {
                  if(_.isUndefined(_this.listOfDealsBeingShown[selectedDeal.id])) {
                    validToProceed = true;
                  }
                });
                if(validToProceed) {
                  _.each(data.selectedDeals,function(selectedDeal) {
                    template = _.template($('#limited-deal-template').html());
                    var dealType = '';
                    if(selectedDeal.starttime > data.timeReference) {
                      dealType = 'deactive';
                    }
                    else if(selectedDeal.endtime < data.timeReference) {
                      dealType = 'sold-out';
                    }
                  compiled_template = template(
                    {limitedDeal:selectedDeal,dealType:dealType,timeReference:data.timeReference}
                    );
                  _this.replaceWithFirstFeasableItem(selectedDeal.id,compiled_template);
                  });
                  _this.$('.deal-box').each(function(){
                    $(this).find('.currency').formatCurrency({
                      symbol: '',
                      roundToDecimalPlace: '-2'
                    });
                  });
                }
              }
            }
          });
    }
  },
  replaceWithFirstFeasableItem: function(productId,content) {
    var validForReplace = true;
    var toBeReplacedElement = null;
    $('.deal-box').each(function(){
      if($(this).data('productid') == productId) {
        toBeReplacedElement = $(this).parents('.deals-wrapper').first();
      }
    });
    if(!toBeReplacedElement) {
      if(this.$('.deals-wrapper.loading').length > 0) {
        toBeReplacedElement = this.$('.deals-wrapper.loading').first();
      }
      else if(this.$('.markedAsDone').length > 0) {
        toBeReplacedElement = this.$('.markedAsDone').first().parents('.deals-wrapper').first();
      }
      else if(this.$('.deals-wrapper .deal-box.deactive').length > 0) {
        toBeReplacedElement = this.$('.deals-wrapper .deal-box.deactive').first().parents('.deals-wrapper').first();
      }
      else if(this.$('.deals-wrapper .deal-box.sold-out').length > 0) {
        toBeReplacedElement = this.$('.deals-wrapper .deal-box.sold-out').first().parents('.deals-wrapper').first();
      }
    }
    if(toBeReplacedElement) {
      toBeReplacedElement.replaceWith(content);
    }
  }
  });
});

